import { RowLayoutMetadata } from "../../common-shared-module/model/dyn-form/form-metadata/layout/row-layout.metadata.model";
import { MetadataFactory } from "../../common-shared-module/model/dyn-form/form-metadata/metadata.factory";
import { DDElement } from "./dd-element.model";
import { Identified } from "./identified.model";
import { Layout } from "./layout.model";
import { RepeatLayout } from "./repeat-layout.model";
import { TableLayout } from "./table-layout.model";


export class RowLayout implements Identified {

    widgets: DDElement[] = []
    layout: Layout | null = null
    metadata: RowLayoutMetadata
    slotsCapacity: number = 3


    constructor(meta?: RowLayoutMetadata) {
        this.metadata = meta ? meta : MetadataFactory.createRowLayout()
    }

    id(): string {
        return this.metadata.id
    }

    thereIsAvailableSlots(requestedSlots: number): boolean {
        let sum = 0
        this.widgets.forEach(p => {
            sum += p.slotWeight()
        })

        if (this.layout != null && this.layout instanceof TableLayout) {
            return this.layout.slotsCapacity >= requestedSlots + sum
        }

        return this.slotsCapacity >= requestedSlots + sum
    }

    destroy(): Layout | null {
        if (this.layout) {
            this.layout.removeRow(this)
            if (this.layout.rows.length == 0) {
                return this.layout
            }
        }

        return null
    }

    isInitInLayout(): boolean {
        if (this.layout == null) return false
        return this.layout.rows[0] == this
    }

    isLastInLayout(): boolean {
        if (this.layout == null) return false
        return this.layout.rows[this.layout.rows.length - 1] == this
    }

    isInLayout() {
        return this.layout != null
    }

    isInTable() {
        return this.isInLayout() && this.layout instanceof TableLayout 
    }

    isInRepeat() {
        return this.isInLayout() && this.layout instanceof RepeatLayout
    }

    removeFromLayout() {
        let l = this.layout
        this.layout = null
        if (l) {
            l.removeRow(this)
        }
    }

    setLayoutAndAfter(newLayout: Layout, rowUp: RowLayout, fromBottom: boolean) {
        this.layout = newLayout
        let i = this.layout.rows.findIndex(r => r == rowUp)
        if (fromBottom) {
            this.layout.rows.splice(i, 1, this, rowUp)
        } else {
            this.layout.rows.splice(i, 1, rowUp, this)
        }
    }

}